import styled from '@emotion/styled';

import { MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';

export const GraphicContainer = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row;
  height: auto;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 20;
`;

export const Graphic = styled.img`
  display: block;
  height: auto;
  width: 55%;

  ${MEDIA_QUERY.DESKTOP} {
    width: 65%;
  }

  ${MEDIA_QUERY.DESKTOP_LG} {
    width: 75%;
  }
`;
